import { gql } from '@apollo/client'

const UNBLOCK_MENU_CURATION_TASK_SUBSCRIPTION = gql`
  subscription onUnblockMenuCurationTask {
    unblockMenuCurationTask {
      menuCurationTaskId
      isUnblockWithError
      reason
    }
  }
`

export default UNBLOCK_MENU_CURATION_TASK_SUBSCRIPTION
